var map = {
	"./backend/backend.module": [
		"../../../../../src/app/backend/backend.module.ts",
		"common",
		"backend.module"
	],
	"./contact/contact.module": [
		"../../../../../src/app/backend/contact/contact.module.ts",
		"common",
		"contact.module"
	],
	"./contents/contents.module": [
		"../../../../../src/app/backend/contents/contents.module.ts",
		"common",
		"contents.module"
	],
	"./faq/faq.module": [
		"../../../../../src/app/backend/faq/faq.module.ts",
		"common",
		"faq.module"
	],
	"./frontend/frontend.module": [
		"../../../../../src/app/frontend/frontend.module.ts",
		"common",
		"frontend.module"
	],
	"./library/library.module": [
		"../../../../../src/app/backend/library/library.module.ts",
		"common",
		"library.module"
	],
	"./pages/pages.module": [
		"../../../../../src/app/backend/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"./personnel/personnel.module": [
		"../../../../../src/app/backend/personnel/personnel.module.ts",
		"common",
		"personnel.module"
	],
	"./results/results.module": [
		"../../../../../src/app/backend/results/results.module.ts",
		"common",
		"results.module"
	],
	"./setting/setting.module": [
		"../../../../../src/app/backend/setting/setting.module.ts",
		"common",
		"setting.module"
	],
	"./slide/slide.module": [
		"../../../../../src/app/backend/setting/slide/slide.module.ts",
		"common",
		"slide.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main